import { FormattedMessage } from 'react-intl';

import { DesktopText, MobileText } from './styles';
import { ResponsiveTextProps } from './types';

const ResponsiveText = ({ text, id }: ResponsiveTextProps) => {
  return (
    <>
      <MobileText>
        <FormattedMessage id={id} defaultMessage={text} values={{ isMobile: true, br: <br /> }} />
      </MobileText>
      <DesktopText>
        <FormattedMessage id={id} defaultMessage={text} values={{ isMobile: false, br: <br /> }} />
      </DesktopText>
    </>
  );
};

export default ResponsiveText;
